var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.24 21.27H14.11C9.67 21.27 7.53 19.52 7.16 15.6C7.12 15.19 7.42 14.82 7.84 14.78C8.25 14.74 8.62 15.05 8.66 15.46C8.95 18.6 10.43 19.77 14.12 19.77H14.25C18.32 19.77 19.76 18.33 19.76 14.26V7.73998C19.76 3.66998 18.32 2.22998 14.25 2.22998H14.12C10.41 2.22998 8.93 3.41998 8.66 6.61998C8.61 7.02998 8.27 7.33998 7.84 7.29998C7.42 7.26998 7.12 6.89998 7.15 6.48998C7.49 2.50998 9.64 0.72998 14.11 0.72998H14.24C19.15 0.72998 21.25 2.82998 21.25 7.73998V14.26C21.25 19.17 19.15 21.27 14.24 21.27Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.88 11.75H1C0.59 11.75 0.25 11.41 0.25 11C0.25 10.59 0.59 10.25 1 10.25H13.88C14.29 10.25 14.63 10.59 14.63 11C14.63 11.41 14.3 11.75 13.88 11.75Z",
    fill: "#757575"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.65 15.1C11.46 15.1 11.27 15.03 11.12 14.88C10.83 14.59 10.83 14.11 11.12 13.82L13.94 11L11.12 8.17998C10.83 7.88998 10.83 7.40998 11.12 7.11998C11.41 6.82998 11.89 6.82998 12.18 7.11998L15.53 10.47C15.82 10.76 15.82 11.24 15.53 11.53L12.18 14.88C12.03 15.03 11.84 15.1 11.65 15.1Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoff);
export default __webpack_public_path__ + "static/media/Logoff.e701ee8c.svg";
export { ForwardRef as ReactComponent };